import { combineReducers } from "redux"
import { reducer as reduxFormReducer } from 'redux-form';
// import { routerReducer } from 'react-router-redux';
import { authentication } from "./authentication";
import { user } from "./user";
import { customers } from "./customers";
import { transactions } from "./transactions";
import { devices } from "./devices";
import { alert } from './alert';
import { userCodes } from './user-codes';
import { otpCodes } from './otp-codes';
import { checkbook } from './checkbook';
import { checkbookEmited } from './checkbook-emited';
import { codes } from './codes';
import { taxes } from './taxes';
import { services } from './services';
import { navigation } from './navigation';
import { taxesTypes } from './taxes-types';
import { beneficiary } from './beneficiary';
import { transfers } from './transfers';
import { permissions } from './permissions'
import { notifications } from './notifications'
import { verificates } from './verificates'

import { balances } from './balances';
import { userCodesCharge } from './user-codes-charges';
import { transferscore } from './transfers-core';
import { entitiesCore } from './entities-core';
import { institutionsCore } from './institutions-core';
import { electricCompaniesCore } from './electric-companies-core';
import { metersCore } from './meters-core';
import { periodsCore } from './periods-core';
import { levelsCore } from './levels-core';
import { agreements } from './agreements';
import { agreementsSwitchServices } from "./agreementsSwitchServices"
import { foundations } from "./foundations"
import { otherServices } from "./otherServices"
import { deposits } from './deposits';
import { loading } from './Loading';
import { parameters } from './parameters';
import { quotas } from './quotas';
//credits core
import { credits } from './credits';
import { siim } from './siim';
import { certificates } from './certificates';
import { agreementTypes } from './agreement-types';
import reduxifyServices from 'feathers-redux';
import client from './../services/feathers'
import { company } from "./company";
import { menu } from "./menu"
import { payrolls } from "./payrolls"
import { states } from "./states"
import { userPermissions } from "./user-permisssions"
import { RESET_STORE } from "../constants";
const servicesFeathers = reduxifyServices(client, ['users', 'codes']);

const rootReducer  =  (state, action) => {
    // console.log('revisando ', state)
    if (action.type === RESET_STORE) {
      state = undefined;
    }
    return appReducer(state, action)
  }

const appReducer =  combineReducers({
    authentication,
    form: reduxFormReducer,
    alert,
    user,
    customers,
    transactions,
    devices,
    userCodes,
    userCodesCharge,
    otpCodes,
    checkbook,
    checkbookEmited,
    codes,
    taxes,
    services,
    taxesTypes,
    navigation,
    users: servicesFeathers.users.reducer,
    newCodes: servicesFeathers.codes.reducer,
    beneficiary,
    transfers,
    permissions,
    notifications,
    verificates,
    balances,
    credits,
    transferscore,
    entitiesCore,
    institutionsCore,
    electricCompaniesCore,
    metersCore,
    periodsCore,
    levelsCore,
    agreements,
    loading,
    deposits,
    parameters,
    quotas,
    siim,
    agreementTypes,
    agreementsSwitchServices,
    otherServices,
    certificates,
    foundations,
    company,
    menu,
    payrolls,
    states,
    userPermissions
})

export default rootReducer;